import { render, staticRenderFns } from "./CytologyResultView.vue?vue&type=template&id=dcbfb806&scoped=true&"
import script from "./CytologyResultView.vue?vue&type=script&lang=js&"
export * from "./CytologyResultView.vue?vue&type=script&lang=js&"
import style0 from "./CytologyResultView.vue?vue&type=style&index=0&id=dcbfb806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbfb806",
  null
  
)

export default component.exports